import React, { useState } from 'react';
import {
  TextField,
  Button,
  Card,
  CardContent,
  LinearProgress, Grid
} from '@material-ui/core';
import { scrapeAmazon } from '../../../services/api';

const ScraperForm = ({ mainBookFormStore }) => {
  const [scrapeUrl, setScrapeUrl] = useState('');
  return (
    <>
      <Card>
        <CardContent>
          <form noValidate autoComplete='off'>
            <Grid container spacing={2} direction="row">
              <Grid item xs={12}>
                <TextField fullWidth label='Buscar livro na amazon'
                           onChange={ (e) => setScrapeUrl(e.target.value) } />
              </Grid>
              <Grid item xs={1}>
                <Button size="large" variant='contained'  color='primary'
                        onClick={ () => mainBookFormStore.searchInAmazon(scrapeUrl) }>Buscar</Button>
              </Grid>
              <Grid item xs={4}>
                <Button size="large" variant='contained'  color='primary' onClick={ () => mainBookFormStore.setManualInput() }>Preenchimento Manual</Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </>
  );
};

export default ScraperForm;
